import React from 'react';
import './ServicesSection.css';

const ServicesSection = () => {
  const services = [
    { icon: '📱', title: 'Mobile App Development', desc: 'Android & iOS Apps' },
    { icon: '🌐', title: 'Web Application Development', desc: 'Modern Web Solutions' },
    { icon: '🤖', title: 'AI Automation & Chatbots', desc: 'Intelligent Automation' },
    { icon: '☁️', title: 'DevOps & Cloud Infrastructure', desc: 'Scalable Cloud Solutions' },
    { icon: '📊', title: 'SAP ERP / GTS / S4HANA', desc: 'Enterprise Resource Planning' },
    { icon: '🔄', title: 'CRM, LMS, HRMS & Billing', desc: 'Business Management Systems' },
    { icon: '📢', title: 'Digital Marketing & SEO', desc: 'Brand Growth & Visibility' },
    { icon: '📈', title: 'Data Science & ML', desc: 'Predictive Analytics' },
    { icon: '🧠', title: 'AI & Data Analytics', desc: 'Machine Learning & Insights' },
    { icon: '🎨', title: 'UI/UX Design', desc: 'User-Centric Interfaces' },
    { icon: '💡', title: 'Product Design', desc: 'Innovation & Consultation' },
    { icon: '⚙️', title: 'Custom Software Solutions', desc: 'Tailored Development' }
  ];

  return (
    <section className="services-section section">
      <div className="section-content">
        <h2 className="section-title">Our Services</h2>
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-desc">{service.desc}</p>
            </div>
          ))}
        </div>
      </div>
      <div className="scroll-indicator">
        <div className="mouse">
          <div className="wheel"></div>
        </div>
      </div>
    </section>
  );
};

export default ServicesSection;
